import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlarm = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.1317 7.49779C10.0199 6.99974 9.45282 4 12 4C14.5472 4 13.9801 6.99974 13.8683 7.49779C13.8576 7.54561 13.8492 7.59193 13.844 7.64066L13.0959 14.6068C13.0414 15.1148 12.6126 15.5 12.1016 15.5H11.8984C11.3874 15.5 10.9586 15.1148 10.9041 14.6068L10.156 7.64066C10.1508 7.59193 10.1424 7.54561 10.1317 7.49779Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 20.8333C12.9205 20.8333 13.6667 20.0871 13.6667 19.1667C13.6667 18.2462 12.9205 17.5 12 17.5C11.0795 17.5 10.3333 18.2462 10.3333 19.1667C10.3333 20.0871 11.0795 20.8333 12 20.8333Z",
		fill: "currentColor"
	})]
});
export default SvgAlarm;
